const initialState = {
    hotelCheckout: {},
  };
  
  const hotelCheckoutReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_HOTEL_CHECKOUT':
        return {
          ...state,
          hotelCheckout: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default hotelCheckoutReducer;
  